module.exports = __webpack_public_path__ + "static/Burst_8-eff210571a4476a32f5aa2151ca612a0.jpg";